import { useState } from 'react';
import { Home, MessageCircle, Wind, TrendingUp, LogOut, Bell } from 'lucide-react';
import HomeScreen from './HomeScreen';
import ChatScreen from './ChatScreen';
import ToolsScreen from './ToolsScreen';
import JourneyScreen from './JourneyScreen';
import { greetByTime } from '../lib/mock';
import { LogoMini } from '../components/Logo';

export default function PatientLayout({ patient, onLogout }) {
  const [tab, setTab] = useState('home');
  const [greet] = useState(greetByTime());

  const tabs = [
    { id: 'home', label: 'الرئيسية', icon: Home },
    { id: 'chat', label: 'الأطباء', icon: MessageCircle },
    { id: 'tools', label: 'أدواتي', icon: Wind },
    { id: 'journey', label: 'رحلتي', icon: TrendingUp }
  ];

  return (
    <div className="phone-shell-frame">
      <div className="phone-shell relative flex flex-col overflow-hidden" style={{ height: '100dvh' }}>
        {/* Header — always visible at top */}
        <div className="glass-warm border-b border-[var(--border-soft)] px-4 py-3 flex items-center gap-3 flex-shrink-0 z-30 safe-top">
          <LogoMini size={40} />
          <div className="flex-1 min-w-0">
            <div className="text-[10.5px] font-semibold" style={{ color: 'var(--text-2)' }}>{greet} ✨</div>
            <div className="text-[14px] font-extrabold truncate" style={{ color: 'var(--text)' }}>{patient.name}</div>
          </div>
          <button className="w-9 h-9 rounded-xl bg-white border border-[var(--border-soft)] hover:border-[var(--primary)] flex items-center justify-center transition-colors relative" data-testid="layout-notif-btn">
            <Bell className="w-4 h-4" style={{ color: 'var(--text-2)' }} />
            <div className="absolute top-1.5 left-1.5 w-2 h-2 rounded-full" style={{ background: 'var(--rose)' }}></div>
          </button>
          <button onClick={onLogout} className="w-9 h-9 rounded-xl bg-white border border-[var(--border-soft)] hover:border-[var(--danger)] flex items-center justify-center transition-colors" data-testid="layout-logout-btn">
            <LogOut className="w-3.5 h-3.5" style={{ color: 'var(--text-2)' }} />
          </button>
        </div>

        {/* Content — the only scrollable area */}
        <div className="flex-1 overflow-y-auto relative min-h-0">
          {tab === 'home' && <HomeScreen patient={patient} onNavigate={setTab} />}
          {tab === 'chat' && <ChatScreen patient={patient} />}
          {tab === 'tools' && <ToolsScreen patient={patient} />}
          {tab === 'journey' && <JourneyScreen patient={patient} />}
        </div>

        {/* Bottom nav — always visible */}
        <div className="flex-shrink-0 z-40 glass-warm border-t border-[var(--border-soft)] px-2 pt-2 pb-3 safe-bottom">
          <div className="flex items-center justify-around">
            {tabs.map(t => {
              const Icon = t.icon;
              const isActive = tab === t.id;
              return (
                <button
                  key={t.id}
                  onClick={() => setTab(t.id)}
                  data-testid={`nav-tab-${t.id}`}
                  className={`flex flex-col items-center gap-1 px-3 py-2 rounded-2xl transition-all duration-300 min-w-[68px] ${
                    isActive ? '' : 'hover:bg-[var(--surface-2)]'
                  }`}
                  style={isActive ? { background: 'linear-gradient(135deg, var(--primary-bg), var(--secondary-bg))', boxShadow: '0 4px 12px rgba(139,127,240,0.15)' } : {}}
                >
                  <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} style={{ color: isActive ? 'var(--primary-dark)' : 'var(--text-2)' }} />
                  <span className={`text-[10.5px]`} style={{ color: isActive ? 'var(--primary-dark)' : 'var(--text-2)', fontWeight: isActive ? 800 : 600 }}>{t.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
